import { render, staticRenderFns } from "./SnowBoxSlideList.vue?vue&type=template&id=0644ad62&scoped=true&"
import script from "./SnowBoxSlideList.vue?vue&type=script&lang=ts&"
export * from "./SnowBoxSlideList.vue?vue&type=script&lang=ts&"
import style0 from "./SnowBoxSlideList.vue?vue&type=style&index=0&id=0644ad62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644ad62",
  null
  
)

export default component.exports